import axios from "axios";
import { createContext, useEffect, useState } from "react";
import { GetMe, SignInApi, SignUpApi, SocialAuthApi } from "../apis/auth";

// third-party
import firebase from 'firebase/compat/app';
import 'firebase/compat/auth';

// firebase
import { firebaseConfig } from '../config';


// set Session
const setSession = (token) => {
  if (token) {
    localStorage.setItem("token", token);
    axios.defaults.headers.common["Authorization"] = `Bearer ${ token }`;
  } else {
    localStorage.removeItem("token");
    delete axios.defaults.headers.common["Authorization"];
  }
};

// ==============================|| JWT CONTEXT & PROVIDER ||============================== //

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [isLoggedIn, setIsLoggedIn] = useState(false);
  const [isInitialized, setIsInitialized] = useState(false);
  const [user, setUser] = useState(null);

  // useEffect
  useEffect(() => {
    const init = async () => {
      try {
        // Initialize Firebase
        firebase.initializeApp(firebaseConfig);
        const serviceToken = window.localStorage.getItem("token");
        if (serviceToken) {
          setSession(serviceToken);
          const response = await GetMe();
          const { user } = response.data;
          setUser(user);
          setIsLoggedIn(true);
          setIsInitialized(true);
        } else {
          setIsLoggedIn(false);
          setIsInitialized(true);
        }
      } catch (err) {
        setSession(null);
        setIsLoggedIn(false);
        setUser(null);
        setIsInitialized(true);
      }
    };
    init();
  }, []);

  // Log in Controller
  const LoginController = async (body) => {
    // todo: this flow need to be recode as it not verified
    const { data } = await SignInApi(body);
    if (data.success) {
      setSession(data.token);
      setUser(data.user);
      setIsLoggedIn(true);
    }
  };

  // Register Controller
  const RegisterController = async (body) => {
    // todo: this flow need to be recode as it not verified
    const { data } = await SignUpApi(body);
    if (data.success) {
      setSession(data.token);
      setUser(data.user);
      setIsLoggedIn(true);
    }
  };

  // log Out
  const logout = () => {
    setSession(null);
    setIsLoggedIn(false);
    setUser(null);
  };

  // social sign in
  const socialSignIn = async (accessToken) => {
    const { data } = await SocialAuthApi({
      accessToken: accessToken,
    });
    setSession(data.token);
    setUser(data.user);
    setIsLoggedIn(true);
  };
  // Google Auth Provider
  const GoogleAuthProvider = new firebase.auth.GoogleAuthProvider();

  // Facebook Auth Provider
  const FacebookAuthProvider = new firebase.auth.FacebookAuthProvider();

  // Google Sign In
  const GoogleSignIn = async () => {
    return await firebase.auth().signInWithPopup(GoogleAuthProvider);
  };

  // Facebook Sign In
  const FacebookSignIn = async () => {
    return await firebase.auth().signInWithPopup(FacebookAuthProvider);
  };

  return (
    <AuthContext.Provider
      value={{
        isLoggedIn,
        isInitialized,
        user,
        LoginController,
        RegisterController,
        logout,
        socialSignIn,
        GoogleSignIn,
        FacebookSignIn,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};


export default AuthContext;
